export default "__VITE_ASSET__Co4ABLyI__"